import React from 'react';
import { useTranslation } from 'react-i18next';
import { CircleDollarSign } from 'lucide-react';
import { useAuthContext } from 'modules/auth/context';
import { formatGroupedNumber } from 'lib/dateFormat';

/**
 * Read-only header readout of the learner's balance, the board's coin chip. The portal balance is the learner's
 * internal credit (1 so'm each), so the figure is the coins; the currency drops off on phones to save width.
 */
export const PortalBalancePill: React.FC = () => {
  const { t } = useTranslation();
  const { state } = useAuthContext();
  const amount = formatGroupedNumber(state.user?.balanceSom ?? 0);
  const currency = t('portal_tests_currency');

  return (
    <span
      role="group"
      title={t('portal.balance')}
      aria-label={`${t('portal.balance')}: ${amount} ${currency}`}
      className="inline-flex h-7 shrink-0 items-center gap-1.5 rounded-full border border-border bg-card px-2.5 text-xs font-semibold tabular-nums text-foreground md:h-8 md:gap-[7px] md:px-3 md:text-[12.5px]"
    >
      <CircleDollarSign size={16} strokeWidth={2} className="shrink-0 text-foreground" aria-hidden="true" />
      <span aria-hidden="true">
        {amount}
        <span className="ml-1 hidden font-normal text-muted-foreground md:inline">{currency}</span>
      </span>
    </span>
  );
};
